import React from 'react'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {dateFormatter} from 'lib/helpers'
import {eq} from 'lodash/lang'
import styles from './claims.scss'
import NoResults from '../noResults'
import TooManyResults from '../tooManyResults'
import underscore from 'underscore'

import i18n from 'lib/i18n'
const _ = i18n('claims')

export default	class ClaimResults extends React.Component {
	static propTypes = {
		data: React.PropTypes.array,
		zoomTo: React.PropTypes.func.isRequired,
	}
	shouldComponentUpdate(nextProps) {
		return !eq(this.props.data, nextProps.data)
    }

    /**
     * This function render the data for the qualification column in the claims result table.
     * @param {object} main - thi is the claims record main property, what contains the qualification values
     */
    formatQualification(main) {
        return (
        <span>
            <span>
                {main.qualification}
            </span>
            {main.subQualification &&
                <span>
                    ,<br/>
                    {main.subQualification}
                </span>
            }
        </span>)
    }

	render() {
		const {data, zoomTo} = this.props
		return (
			<div className={styles.claimsTableContainer}>
				{ data && underscore.isArray(data) && data[0] !== 'Too many rows' &&
				<Table
					className={styles.table}
					itemsPerPage={20}
					filterable={[
						"clientName",
						"claimDate",
						"creationDate",
						"claimNumber",
						"contractNumber",
						"insuranceCompany",
						"claimsManager",
						"qualification",
						"state",
					]}
					sortable={[
							{column: 'claimDate', sortFunction: 'Date'},
							{column: 'creationDate', sortFunction: 'Date'},
						"clientName",
						"claimNumber",
						"contractNumber",
						"insuranceCompany",
                        "claimsManager",
                        'qualification',
						"state",
					]}
					defaultSort={{
						column: 'creationDate',
						direction: 'desc',
					}}
				>
					<Thead>
						<Th column="clientName">
							<strong>{_('clientName')}</strong>
						</Th>
						<Th column="claimDate">
							<strong>{_('date')}</strong>
						</Th>
						<Th column="creationDate">
							<strong>{_('creationDate')}</strong>
						</Th>
						<Th column="claimNumber">
							<strong>{_('claimNumber')}</strong>
						</Th>
						<Th column="contractNumber">
							<strong>{_('contractNumber')}</strong>
						</Th>
						<Th column="insuranceCompany">
							<strong>{_('insuranceCompany')}</strong>
						</Th>
						<Th column="claimsManager">
							<strong>{_('claimsManager')}</strong>
						</Th>
						<Th column="qualification">
							<strong>{_('qualification')}</strong>
						</Th>
						<Th column="state">
							<strong>{_('status')}</strong>
						</Th>
					</Thead>
					{ data.map(({main, details}, key) => (
						<Tr
							key={key}
							className="clickable centered"
							onClick={() => zoomTo(main)}
						>
							<Td column="clientName">{main.clientName}</Td>
							<Td column="claimDate" data={dateFormatter(main.claimDate)}/>
							<Td column="creationDate" data={dateFormatter(main.creationDate)}/>
							<Td column="claimNumber">{main.claimNumber}</Td>
							<Td column="contractNumber">{main.contractNumber}</Td>
							<Td column="insuranceCompany">{details.insuranceCompany}</Td>
							<Td column="claimsManager">{main.claimsManager}</Td>
                            <Td column="qualification" data={this.formatQualification(main)} value={main.qualification + " " + main.subQualification}/>
							<Td column="state">{main.state}</Td>
						</Tr>
						))}
				</Table>
				}
				{ data && underscore.isArray(data) && data.length === 0 &&
				<NoResults type="claims"/>
				}
				{ data && underscore.isArray(data) && data[0] === 'Too many rows' &&
				<TooManyResults	type="claims"/>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/claims/claimResults.jsx